import { lazy, Suspense } from 'react';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

// The About page is a separate, lazily loaded chunk; the map is the main event.
const About = lazy(() => import('./components/About'));

/** Routes by path: /about, otherwise the map. */
export function Root({ path }: { path: string }) {
  return (
    <ErrorBoundary>
      {path === '/about' ? (
        <Suspense fallback={<p className="about__loading">Loading…</p>}>
          <About />
        </Suspense>
      ) : (
        <App />
      )}
    </ErrorBoundary>
  );
}
